import { Add, AddCircleOutline, Close, Search } from "@mui/icons-material";
import {
  Avatar,
  Box,
  Collapse,
  IconButton,
  InputBase,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Slide,
  Stack,
  Typography,
} from "@mui/material";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { uploadDataWithName } from "../../libs/firebase/firestore/uploadDataWithName";
import Color from "./Colour";
import PlantListItem from "./Plant/ListItem";

function groupPlants(plants) {
  // go through the array of plants and group them by name as another array
  let groupedPlants = [];
  let plantIndexDict = {};
  plants.forEach((plant) => {
    // check plantIndexDict for plant name
    let index = plantIndexDict[plant.name];
    if (index == undefined) {
      groupedPlants.push(plant);
      plantIndexDict[plant.name] = groupedPlants.length - 1;
    } else {
      // array inside array

      //if is array
      if (!Array.isArray(groupedPlants[index])) {
        groupedPlants[index] = [groupedPlants[index]];
      }
      groupedPlants[index] = [...groupedPlants[index], plant];
    }
  });
  return groupedPlants;
}

const PlantList = ({
  plants = [],
  allPlants = [],
  onAddPlant,
  onCreatePlant,
  onDeletePlant,
  onPlantClick,
  selectedPlant,
  onClose,
  open = false,
  title = "Plants",
  siteUid,
}) => {
  const [searchValue, setSearchValue] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  // const [, setSelectedPlant] = useState(null);
  const searchRef = useRef(null);

  useEffect(() => {
    if (isSearching && searchRef.current) {
      searchRef.current.focus();
    }
  }, [isSearching]);

  const handleAddPlantClicked = () => {
    setIsSearching(true);
  };

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  const handleSearchClose = () => {
    setIsSearching(false);
    setSearchValue("");
  };

  // const handlePlantClick = (plant) => {
  //   // toggle selected plant
  //   if (selectedPlant && selectedPlant === plant) {
  //     console.log("deselecting plant", selectedPlant, plant);
  //     setSelectedPlant(null);
  //   } else {
  //     setSelectedPlant(plant);
  //   }
  // };
  const handleCreatePlant = () => {
    const request = {
      name: searchValue,
    };
    uploadDataWithName(
      request,
      "plants",
      request.name,
      () => {
        // update the plants state
        // let newPlants = [...allPlants, request.name];
        // setPlants(newPlants);

        // update plant information on firebase
        onCreatePlant(request.name, () => {
          onAddPlant(request);
        });

        alert("Plant information submitted successfully!");
      },
      (error) => {
        console.error("Error submitting plant information: ", error);
        alert("Error submitting plant information. Please try again later.");
      }
    );
  };

  const handlePlantSelect = (plant) => {
    const plantData = {
      name: plant.name,
      quantity: 1,
      image: plant.plantImage,
    };
    onAddPlant(plantData);
    handleSearchClose();
  };

  const handleDeletePlant = (plant) => {
    // TODO: Implement delete plant functionality
    onDeletePlant(plant);
  };

  const handleDrawPlant = (plant) => {
    // TODO: Implement draw plant functionality
  };
  const handleGpsPlant = (plant) => {
    if (!plant.x) {
      plant.x = 100;
    }
    if (!plant.y) {
      plant.y = 100;
    }
  };

  const filteredPlants = allPlants.filter((plant) =>
    plant.name.toLowerCase().includes(searchValue.toLowerCase())
  );

  const sortedPlants = plants.sort((a, b) => {
    if (a.name < b.name) return -1;
    return 1;
  });

  const groupedPlants = groupPlants(sortedPlants);

  return (
    <Slide direction="up" in={open}>
      <Box
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          height: "33%",
          backgroundColor: "#fff",
          zIndex: 1300,
          overflowX: "auto",
          padding: "16px",
          display: "flex",
          // alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Stack direction={"row"}>
          <Typography variant="h5" style={{ marginBottom: "16px" }}>
            {title}
          </Typography>
          <div style={{ flexGrow: 1 }}></div>
          {isSearching ? (
            <IconButton onClick={handleSearchClose}>
              <Close />
            </IconButton>
          ) : (
            <>
              <IconButton onClick={handleAddPlantClicked}>
                <AddCircleOutline />
              </IconButton>
              <IconButton onClick={onClose}>
                <Close />
              </IconButton>
            </>
          )}
        </Stack>

        <Color plants={plants} allPlants={allPlants} />

        {isSearching ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              borderRadius: 2,
              backgroundColor: "#f2f2f2",
              padding: "2px 4px",
              marginBottom: "16px",
            }}
          >
            <IconButton sx={{ p: "10px" }} aria-label="search">
              <Search />
            </IconButton>
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="Search for a plant"
              value={searchValue}
              onChange={handleSearchChange}
              inputRef={searchRef}
            />
          </Box>
        ) : null}

        <List>
          {isSearching
            ? filteredPlants.map((plant) => (
                <ListItem
                  key={plant.name}
                  style={{ cursor: "pointer" }}
                  onClick={() => handlePlantSelect(plant)}
                >
                  <ListItemAvatar>
                    <Avatar src={plant.image} alt={plant.name} />
                  </ListItemAvatar>
                  <ListItemText primary={plant.name} />
                </ListItem>
              ))
            : groupedPlants.map((plant, i) => (
                <PlantListItem
                  key={i}
                  plant={plant}
                  selectedPlant={selectedPlant}
                  onPlantClick={onPlantClick}
                  onAddPlant={onAddPlant}
                  handleDeletePlant={handleDeletePlant}
                  handleGpsPlant={handleGpsPlant}
                  siteUid={siteUid}
                />
              ))}

          {isSearching && (
            // list item to create plant
            <ListItem style={{ cursor: "pointer" }} onClick={handleCreatePlant}>
              <ListItemAvatar>
                <Avatar>
                  <Add />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary="Create Plant" />
            </ListItem>
          )}
        </List>
      </Box>
    </Slide>
  );
};

export default PlantList;
